export default __webpack_public_path__ + "static/media/IMG_1616.25d43fbb.JPG";